import { render, staticRenderFns } from "./shareholderdividends.vue?vue&type=template&id=62c66992&scoped=true"
import script from "./shareholderdividends.vue?vue&type=script&lang=js"
export * from "./shareholderdividends.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62c66992",
  null
  
)

export default component.exports